/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ApiRequestEmployerStatistic } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface GroupV2StatisticsServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * 
     * 
     * @param apiRequestEmployerStatistic 
     */
    groupV2StatisticsControllerFindTotalAmountOfGroupsByEmployer0(apiRequestEmployerStatistic: ApiRequestEmployerStatistic, extraHttpRequestParams?: any): Observable<number>;

    /**
     * 
     * 
     * @param apiRequestEmployerStatistic 
     */
    groupV2StatisticsControllerFindTotalAmountOfGroupsByEmployer1(apiRequestEmployerStatistic: ApiRequestEmployerStatistic, extraHttpRequestParams?: any): Observable<number>;

    /**
     * 
     * 
     * @param apiRequestEmployerStatistic 
     */
    groupV2StatisticsControllerGetAverageGroupSizeByEmployer0(apiRequestEmployerStatistic: ApiRequestEmployerStatistic, extraHttpRequestParams?: any): Observable<number>;

    /**
     * 
     * 
     * @param apiRequestEmployerStatistic 
     */
    groupV2StatisticsControllerGetAverageGroupSizeByEmployer1(apiRequestEmployerStatistic: ApiRequestEmployerStatistic, extraHttpRequestParams?: any): Observable<number>;

}
